import { useStaticQuery, graphql } from 'gatsby'
import { GraphqlMarkdownI, GraphqlMarkdownNodeI, AllFileQueryI } from '../types/common'
import { CategoryI } from '../types/data-models'

interface UseTagsQueryI {
  tags: GraphqlMarkdownI<CategoryI>
  coverImages: AllFileQueryI
  thumbnails: AllFileQueryI
}

// TODO: image transformations here for cover image
const useTags = (): UseTagsQueryI => {
  const { tags, coverImages, thumbnails } = useStaticQuery(
    graphql`
      query {
        tags: allMarkdownRemark(filter: { fields: { type: { eq: "TAG" } } }) {
          edges {
            node {
              fields {
                slug
              }
              frontmatter {
                title
                subtitle
                description
                coverImage {
                  label
                  url
                }
              }
            }
          }
        }
      }
    `
  )
  return { tags, coverImages, thumbnails }
}

export default useTags

export const getOtherTags = (tagName: string): GraphqlMarkdownNodeI<CategoryI>[] => {
  const { tags } = useTags()
  const otherTags = tags.edges.filter((item) => item.node.frontmatter.title !== tagName)
  return otherTags
}

export const getTagByTitle = (tags: GraphqlMarkdownI<CategoryI>, tagName: string): GraphqlMarkdownNodeI<CategoryI> => {
  const tag = tags.edges.find((item) => item.node.frontmatter.title === tagName)
  return tag as GraphqlMarkdownNodeI<CategoryI>
}

export const getSlugOfTag = (tagTitle: string): string => {
  const { tags } = useTags()
  const tag = tags.edges.find((item) => item.node.frontmatter.title === tagTitle)
  const slug = tag?.node.fields.slug
  if (!slug) return '/404'
  return slug
}
